module.exports = __webpack_public_path__ + "img/battery_5disable.97681f81.png";